export default __webpack_public_path__ + "static/media/vanderlei.9303df2b.jpg";